// These helpers abstract the Browser native APIs
// so that we can easily mock the navigation in our tests
export const navigateTo = (url: string) => {
  location.assign(url);
};

export const openInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
